import React from 'react';

const Paging = ({ currentPage, pageCount, handlePageClick, disabled = false, className = '' }) => {
  const count = Number.isFinite(Number(pageCount)) ? Math.max(0, Math.floor(Number(pageCount))) : 0;
  const requestedPage = Number.isFinite(Number(currentPage)) ? Number(currentPage) : 1;
  const page = Math.min(count, Math.max(1, Math.floor(requestedPage)));
  if (count <= 1) return null;

  const pages = new Set([1, count]);
  const start = Math.max(2, Math.min(page - 1, count - 4));
  const end = Math.min(count - 1, Math.max(page + 1, 5));
  for (let number = start; number <= end; number++) pages.add(number);
  const items = [...pages].sort((a, b) => a - b);
  const buttonClass =
    'inline-flex h-10 min-w-10 items-center justify-center rounded-lg border border-gray-200 bg-white px-3 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/30 disabled:cursor-not-allowed disabled:opacity-50';
  const goToPage = (number) => {
    if (!disabled && number >= 1 && number <= count && number !== page) handlePageClick?.(number);
  };

  return (
    <nav
      className={`flex flex-wrap items-center gap-2 ${className}`}
      aria-label='Navigasi halaman'
      aria-disabled={disabled || undefined}
    >
      <button
        type='button'
        className={buttonClass}
        disabled={disabled || page <= 1}
        onClick={() => goToPage(page - 1)}
        aria-label='Halaman sebelumnya'
      >
        Sebelumnya
      </button>
      {items.map((number, index) => (
        <React.Fragment key={number}>
          {index > 0 && number - items[index - 1] > 1 && (
            <span className='px-1 text-gray-400' aria-hidden='true'>
              …
            </span>
          )}
          <button
            type='button'
            disabled={disabled}
            onClick={() => goToPage(number)}
            aria-label={`Halaman ${number}`}
            aria-current={number === page ? 'page' : undefined}
            className={`${buttonClass} ${number === page ? 'border-teal-500! bg-teal-500! text-white! hover:bg-teal-600!' : ''}`}
          >
            {number}
          </button>
        </React.Fragment>
      ))}
      <button
        type='button'
        className={buttonClass}
        disabled={disabled || page >= count}
        onClick={() => goToPage(page + 1)}
        aria-label='Halaman berikutnya'
      >
        Selanjutnya
      </button>
    </nav>
  );
};

export default Paging;
